



























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import T from '../../lang';
import { types } from '../../api_types';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
@Component({
  components: {
    'vue-typeahead-bootstrap': VueTypeaheadBootstrap,
  },
})
export default class FilterTags extends Vue {
  @Prop() publicQualityTags!: types.TagWithProblemCount[];
  @Prop({ default: () => [] }) tags!: types.TagWithProblemCount[];
  @Prop({ default: () => [] }) selectedTags!: string[];

  T = T;
  currentSelectedTags = this.selectedTags;

  get publicQualityTagNames(): string[] {
    return this.publicQualityTags.map((x) => x.name);
  }

  addOtherTag(tag: string): void {
    if (!this.currentSelectedTags.includes(tag)) {
      this.currentSelectedTags.push(tag);
    }
  }

  publicQualityTagsSerializer(name: string): string {
    if (Object.prototype.hasOwnProperty.call(T, name)) {
      return T[name];
    }
    return name;
  }

  @Watch('currentSelectedTags')
  onNewTagSelected(): void {
    this.$emit('new-selected-tag', this.currentSelectedTags);
  }
}
